export default function ({store}) {
    if (!store.state.token) {
        store.commit('SET_ISSHOWLOGIN', true);
    }
}
